import { useMasterData } from '../../../hooks/api/useMasterData'
import { useDispatch, useSelector } from 'react-redux'
import { clearSelectedSetup, selectSetupName } from '../../../features/system/systemSlice'
import { setSetup } from '../../../features/setup/setupSlice'
import SetupTHead from '../theads/SetupTHead'
import { setUpAddons } from '../../../data/admin-data'
import SetupAddonsTBody from '../tbody/SetupAddonTBody'
import SetupHeader from '../headers/SetupHeader'

export default function SetupAddons() {

    const dispatch = useDispatch()
    const { addOns, isLoadingAddOns, isErrorAddOns, errorMessageAddOns, } = useMasterData()
    const selectedSetupName = useSelector(selectSetupName)

    return (
        <>
            <SetupHeader
                onClick={() => dispatch(clearSelectedSetup())}
                handleClickNew={() => dispatch(setSetup({ type: 'show', value: 'setUpAddons'}))}
                selectedSetupName={selectedSetupName}
            />
            <div className='h-full overflow-hidden bg-white rounded border'>
                <div className='overflow-y-auto h-full'>
                    <table className='min-w-max w-full'>
                        <SetupTHead data={setUpAddons}/> 
                        <SetupAddonsTBody
                            data={addOns}
                            isLoading={isLoadingAddOns}
                            isError={isErrorAddOns}
                            errorMessage={errorMessageAddOns}
                            isEmpty={addOns.length === 0}
                        />
                    </table>
                </div>
            </div>
        </>
    )
}
